import { clearFreshLogin, markFreshLogin } from './fresh-login'

/**
 * Redux middleware that sets the fresh-login flag exactly when a real
 * username/password or MFA login succeeds.
 *
 * Action flow from @hixme/auth-ui:
 *   Fresh login  → REQUEST_SUCCESS (name: 'login' | 'mfaLogin') → LOGIN_USER_SUCCESS
 *   Page reload  → LOGIN_USER_SUCCESS (no REQUEST_SUCCESS before it)
 *   Token refresh → REQUEST_SUCCESS (name: 'refreshCredentials') → LOGIN_USER_SUCCESS
 *
 * By remembering the name of the last REQUEST_SUCCESS, we can distinguish a
 * real login from a restore or refresh when LOGIN_USER_SUCCESS fires.
 */
export const demoLoginEventMiddleware = () => (next) => {
  /** The `name` field of the most recent authui/REQUEST_SUCCESS, or null. */
  let lastRequestName = null

  return (action) => {
    const result = next(action)

    if (action.type === 'authui/REQUEST_SUCCESS') {
      lastRequestName = action.payload?.name ?? null
    }

    if (action.type === 'authui/LOGIN_USER_SUCCESS') {
      if (lastRequestName === 'login' || lastRequestName === 'mfaLogin') {
        markFreshLogin()
      }
      // Reset so a subsequent refresh doesn't re-trigger.
      lastRequestName = null
    }

    if (action.type === 'authui/LOGOUT_USER') {
      clearFreshLogin()
      lastRequestName = null
    }

    return result
  }
}
